import FinalTreatmentHeader from "./Header";
import "./index.css";
import { useState } from "react";
import FinalTreatmentOwnContents from "./FinalTreatmentOwn";
import FinalTreatmentUnsoldContents from "./FinalTreatmentUnsold";
import FinalTreatmentPackagingContents from "./FinalTreatmentPackaging";
import { ShowHide } from "../components/ShowHideProduct";
import FlowNumbersBox from "../components/FlowNumbersBox";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";
const FinalTreatmentComponent = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });
  return (
    <div className="final-treatment-container" id="final-treatment-id">
      <FinalTreatmentHeader productId={productId} show={show} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />

        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox
            isNormal={true}
            number={"Flow 18"}
            color={"#193666"}
          />
        </div>
      </div>
      {show && (
        <FinalTreatmentOwnContents
          productId={productId}
          category={"Product Own Not Received"}
        />
      )}
      {/* {show && (
        <FinalTreatmentOwnContents
          productId={productId}
          category={"Product Own Received"}
        />
      )}

      {show && (
        <FinalTreatmentPackagingContents
          productId={productId}
          category={"Product Packaging Not Received"}
        />
      )}
      {show && (
        <FinalTreatmentPackagingContents
          productId={productId}
          category={"Product Packaging Received"}
        />
      )}
      {show && (
        <FinalTreatmentUnsoldContents
          productId={productId}
          category={"Product Unsold Not Received"}
        />
      )}
      {show && (
        <FinalTreatmentUnsoldContents
          productId={productId}
          category={"Product Unsold Received"}
        />
      )} */}
    </div>
  );
};

export default FinalTreatmentComponent;
